import { useEffect } from 'react';
import clsx from 'clsx';
import { Box, Modal } from '@mui/material';

import { Heading, Text } from '../../../../packages';
import { Icons } from '../../../../packages';
import { btnType, Button } from '../../../../packages/ui/atoms/button';
import { colors } from '../../../../packages/colors';

import { useStyles } from './SessionModalPopup.styles';

const SessionModalPopup = ({
  icon,
  open,
  title,
  content,
  lbtnLabel,
  rbtnLabel,
  onClose,
  isLoading,
  onCancel,
  onSubmit,
  isDelete,
}) => {
  const classes = useStyles();

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.shiftKey && e.key === ' ') {
        e.preventDefault();
        onCancel?.();
      }

      if (e.key === ' ' && !e.shiftKey) {
        e.preventDefault();
        onSubmit?.();
      }
    };

    if (open) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose, onCancel, onSubmit]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modal}>
        <Box className={classes.modalContent}>
          {icon && (
            <Box className={classes.editIconWrap}>
              <Icons glyph={icon} className={classes.editIcon} />
            </Box>
          )}
          <Box className={classes.content}>
            <Box>
              <Heading className={classes.title}>{title}</Heading>
              <Text className={classes.subtitle}>{content}</Text>
              <Icons glyph="close" onClick={onClose} className={classes.closeBtn} color={colors.neutral400} />
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" gap="16px">
              <Button
                className={clsx(classes.modalBtn, classes.cancelBtn)}
                disabled={isLoading}
                onClick={onCancel || onClose}
                variant={btnType.OUTLINE}
              >
                {lbtnLabel}
              </Button>
              <Button
                className={clsx(classes.modalBtn, isDelete ? classes.deleteBtn : classes.okBtn)}
                disabled={isLoading}
                onClick={onSubmit}
              >
                {rbtnLabel}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SessionModalPopup;
